import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Param, Post, Query, Req, Res, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { ApiConsumes, ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { GetReportsByCmntIdDTO, GetReportsByPostIdDTO, GetReportsByUserIdDTO, ReportDTO } from './dto/report.dto';
import { AllReportsResponseModel, ReportsResponseModel } from './dto/reports-response-module';
import { ReportService } from './report.service';
import { FileFieldsInterceptor, FilesInterceptor } from '@nestjs/platform-express';
import { extname } from 'path';
import { diskStorage } from 'multer';
import { imageFileFilter } from '../shared/file-upload';

@ApiTags('Report')
@Controller('report')
export class ReportController {

    constructor (
        private ReportService:ReportService
    ) {}
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/createReport')
    @ApiQuery({name:'apiVersion'})
    @UseInterceptors(
		FilesInterceptor('Image', 1, {
			fileFilter: imageFileFilter,
			storage: diskStorage({
				destination: './public/reportPic',
				filename: function (req, file, callback) {
					const name = file.originalname.split('.')[0];
					const fileExtName = extname(file.originalname);
					const randomName = Array(4)
						.fill(null)
						.map(() => Math.round(Math.random() * 16).toString(16))
						.join('');
					callback(null, `${name}-${randomName}${fileExtName}`);
				}
			}),			
		}),
    )
    @ApiConsumes('multipart/form-data')
    async createReport(@Query() queryParams, @UploadedFiles() Image,@Body() reportDto:ReportDTO, @Req() request: Request): Promise<ReportsResponseModel> {
        try {
            const response = [];
            Image.forEach(file => {
                const fileReponse = {
                    ImageLocation: `report/reportPic/${file.filename}`,                               
                };
               response.push(fileReponse);
            })
            return await this.ReportService.createReport(queryParams,response, reportDto, request);
        } catch (error) {
            return errorHandler(ReportsResponseModel, error);
        }
    }

    @Get('/reportPic/:imgpath')
    @ApiOperation({summary:'picture display'})
    @ApiParam({name:'imgpath'})
    async seeUploadedPic(@Param('imgpath') Image, @Res() res) {
		try {
			return res.sendFile(Image, { root: './public/reportPic' });
		} catch (error) {
			return error.message;
		}
    }

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/getReportsByPostId')
    @ApiQuery({name:'apiVersion'})
    async getReportsByPostId(@Query() queryParams,@Body() getReportsByPostIdDto:GetReportsByPostIdDTO,request: Request): Promise<AllReportsResponseModel> {
        try {
            return await this.ReportService.getReportsByPostId(queryParams,getReportsByPostIdDto,request);
        } catch (error) {
            return errorHandler(AllReportsResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/getReportsByCommentId')
    @ApiQuery({name:'apiVersion'})
    async getReportsByCommentId(@Query() queryParams,@Body() getReportsByCmntIdDto:GetReportsByCmntIdDTO,request: Request): Promise<AllReportsResponseModel> {
        try {
            return await this.ReportService.getReportsByCommentId(queryParams,getReportsByCmntIdDto,request);
        } catch (error) {
            return errorHandler(AllReportsResponseModel, error);
        }
    }
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Post('/getReportsByUserId')
    @ApiQuery({name:'apiVersion'})
    async getReportsByUserId(@Query() queryParams,@Body() getReportsByUserIdDTO:GetReportsByUserIdDTO,request: Request): Promise<AllReportsResponseModel> {
        try {
            return await this.ReportService.getReportsByUserId(queryParams,getReportsByUserIdDTO,request);
        } catch (error) {
            return errorHandler(AllReportsResponseModel, error);
        }
    }
}
